(() => {
  const GLOBAL_KEY = 'TDBundleReturnLink';

  if (window[GLOBAL_KEY]) {
    window[GLOBAL_KEY].init(document);
    return;
  }

  const initializedElements = new WeakSet();
  const selector = 'td-feeding-offer-picker, td-travel-offer-picker';
  const propertyName = 'properties[_td_return_url]';
  const offerParameter = 'td_offer';

  const configurations = {
    'td-feeding-offer-picker': {
      returnOffer: 'zone',
      formOfferDataset: 'tdFeedingOffer',
      mainVariantDataset: 'tdFeedingMainVariantId'
    },
    'td-travel-offer-picker': {
      returnOffer: 'bundle',
      formOfferDataset: 'tdTravelOffer',
      mainVariantDataset: 'tdTravelMainVariantId'
    }
  };

  function getForm(element) {
    return document.getElementById(element.dataset.formId || '');
  }

  function getMainSection(element) {
    return document.getElementById(
      `MainProduct-${element.dataset.sectionId || ''}`
    ) || element.closest('[id^="MainProduct-"]');
  }

  function getReturnInput(form) {
    let input = form.querySelector(
      '[data-td-bundle-return-property]'
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = propertyName;
      input.setAttribute('data-td-bundle-return-property', '');
      input.disabled = true;
      form.appendChild(input);
    }

    return input;
  }

  function getSelectedOffer(element, form, configuration) {
    const checked = element.querySelector(
      '[data-offer-key]:checked'
    );

    return checked?.dataset.offerKey
      || form.dataset[configuration.formOfferDataset]
      || 'solo';
  }

  function buildReturnUrl(element, form, configuration) {
    const section = getMainSection(element);
    const productUrl = section?.dataset.tdProductUrl || '';
    const mainVariantId = String(
      form.dataset[configuration.mainVariantDataset] || ''
    ).trim();

    if (!productUrl || !/^\d+$/.test(mainVariantId)) {
      return '';
    }

    try {
      const url = new URL(productUrl, window.location.origin);

      url.search = '';
      url.hash = '';
      url.searchParams.set('variant', mainVariantId);
      url.searchParams.set(
        offerParameter,
        configuration.returnOffer
      );

      return `${url.pathname}${url.search}`;
    } catch (error) {
      return '';
    }
  }

  function syncReturnProperty(element, form, configuration) {
    const input = getReturnInput(form);
    const selectedOffer = getSelectedOffer(
      element,
      form,
      configuration
    );

    const shouldReturn =
      selectedOffer === configuration.returnOffer;

    const returnUrl = shouldReturn
      ? buildReturnUrl(element, form, configuration)
      : '';

    input.value = returnUrl;
    input.disabled = !returnUrl;
  }

  function restoreOfferFromUrl(
    element,
    form,
    configuration
  ) {
    const requestedOffer = new URL(
      window.location.href
    ).searchParams.get(offerParameter);

    if (requestedOffer !== configuration.returnOffer) {
      return;
    }

    const radio = Array.from(
      element.querySelectorAll('[data-offer-key]')
    ).find((candidate) => {
      return candidate.dataset.offerKey === requestedOffer;
    });

    if (!radio || radio.disabled) {
      return;
    }

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(
        new Event('change', { bubbles: true })
      );
    }

    window.requestAnimationFrame(() => {
      syncReturnProperty(element, form, configuration);
    });
  }

  function initializeElement(element) {
    const tagName = element.localName;
    const configuration = configurations[tagName];

    if (!configuration || initializedElements.has(element)) {
      return;
    }

    if (!window.customElements?.get(tagName)) {
      window.customElements
        ?.whenDefined(tagName)
        .then(() => initializeElement(element));

      return;
    }

    const form = getForm(element);

    if (!form) {
      return;
    }

    initializedElements.add(element);

    element.addEventListener('change', () => {
      window.requestAnimationFrame(() => {
        syncReturnProperty(
          element,
          form,
          configuration
        );
      });
    });

    form.addEventListener(
      'submit',
      () => {
        syncReturnProperty(
          element,
          form,
          configuration
        );
      },
      true
    );

    restoreOfferFromUrl(
      element,
      form,
      configuration
    );

    syncReturnProperty(
      element,
      form,
      configuration
    );
  }

  function init(root = document) {
    if (root.matches?.(selector)) {
      initializeElement(root);
    }

    root
      .querySelectorAll?.(selector)
      .forEach(initializeElement);
  }

  window[GLOBAL_KEY] = { init };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(document),
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      init(event.target);
    }
  );
})();